import { INITIAL_DATE } from "../../utils/constants";
import { formatDateFromAPI } from "../../utils/formatDate";
import { SAVE_ND_INFO, CLEAR_APPLICATION_DATA } from "../constant";

export const ndInitialState = (data) => ({
	studentTypeId: data?.studentTypeId,
	...(data?.applicationType && {
		applicationType: {
			label: data?.applicationType,
			value: data?.applicationTypeId
		}
	}),
	applicationNumber: data?.personalDataResponse?.applicationNumber,
	passport: {
		passport: data?.passport
	},
	personalInfo: {
		firstname: data?.personalDataResponse?.firstname,
		middlename: data?.personalDataResponse?.middlename,
		surname: data?.personalDataResponse?.lastname,
		...(data?.personalDataResponse?.gender && {
			sex: {
				label: data?.personalDataResponse?.gender,
				value: data?.personalDataResponse?.genderId
			}
		}),
		...(data?.personalDataResponse?.dateOfBirth && {
			dateOfBirth:
				data?.personalDataResponse?.dateOfBirth === INITIAL_DATE
					? ""
					: formatDateFromAPI(data?.personalDataResponse?.dateOfBirth)
		}),
		nin: data?.personalDataResponse?.nin,
		abssinNumber: data?.personalDataResponse?.abssinNumber,
		electoralWard: data?.personalDataResponse?.electoralWard,
		mobileNo: data?.personalDataResponse?.mobileNumber,
		email: data?.personalDataResponse?.email,
		occupation: data?.personalDataResponse?.occupation,
		...(data?.personalDataResponse?.country && {
			country: {
				label: data?.personalDataResponse?.country,
				value: data?.personalDataResponse?.countryId
			}
		}),
		...(data?.personalDataResponse?.maritalStatus && {
			maritalStatus: {
				label: data?.personalDataResponse?.maritalStatus,
				value: data?.personalDataResponse?.maritalStatusId
			}
		}),
		...(data?.personalDataResponse?.state && {
			state: {
				label: data?.personalDataResponse?.state,
				value: data?.personalDataResponse?.stateId
			}
		}),
		...(data?.personalDataResponse?.stateOfResidence && {
			stateOfResidence: {
				label: data?.personalDataResponse?.stateOfResidence,
				value: data?.personalDataResponse?.stateOfResidenceId
			}
		}),
		...(data?.personalDataResponse?.lga && {
			lga: {
				label: data?.personalDataResponse?.lga,
				value: data?.personalDataResponse?.lgaId
			}
		}),
		contactAddress: data?.personalDataResponse?.contactAddress,
		permanentAddress: data?.personalDataResponse?.permanentAddress,
		rrr: data?.personalDataResponse?.rrr
	},
	programmeInfo: {
		...(data?.programme?.facultyId && {
			faculty: {
				label: data?.programme?.faculty,
				value: data?.programme?.facultyId
			}
		}),
		...(data?.programme?.departmentId && {
			department: {
				label: data?.programme?.department,
				value: data?.programme?.departmentId
			}
		}),
		...(data?.programme?.departmentOptionId && {
			departmentOption: {
				label: data?.programme?.departmentOption,
				value: data?.programme?.departmentOptionId
			}
		})
	},
	oLevelResponse: {
		sittings:
			data?.olevelResponse?.map((item) => ({
				...item,
				resultPin: item?.resultPin,
				resultPinSno: item?.resultSerialNumber,
				examNumber: item?.examNumber,
				examCentre: item?.examCenter,
				oLevelType: {
					value: item?.examinationTypeId,
					label: item?.examinationType
				},
				examYear: { value: item?.examYear, label: item?.examYear },
				subjects: [
					...Object?.keys(item?.subjectGrade).map((key, index) => ({
						subject: {
							label: key?.toUpperCase(),
							value: Object?.keys(item?.subjectGradeId)?.[index]
						},
						grade: {
							label: item?.subjectGrade?.[key],
							value: Object?.values(item?.subjectGradeId)?.[index]
						}
					}))
				]
			})) || []
	},

	educationalRecord: data?.educationalRecord || []
});

export const ndReducer = (state = {}, action) => {
	switch (action.type) {
		case SAVE_ND_INFO:
			return action.payload;
		case CLEAR_APPLICATION_DATA:
			return {};
		default:
			return state;
	}
};
